import { render } from "./IndexParametre.vue?vue&type=template&id=77af1798"
import script from "./IndexParametre.vue?vue&type=script&lang=js"
export * from "./IndexParametre.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__